import AdoptionActions from './actions'

const initialState = {
  isModalOpen: false,
  isFetching: false,
  isError: false,
  messageError: null,
  adoptions: [],
  segments: [],
  grades: [],
  adoptionDueDate: '',
  selectedGrades: [],
  filterGradeId: 0,
  filter: {
    intelligenceScopes: [],
    onuGroups: [],
    onuGoals: [],
    twentyfirstCompetences: [],
    twentyfirstSkills: [],
    oostSubjects: [],
    sels: [],
    teachers: [],
    status: [],
    subjects: [],
    gradeId: 0
  },
  triggerFetchAdoptionsToBeSent: false,
  adoptionsSend: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null
  },
  dialog: {
    isOpen: false,
    item: null
  },
  paginate: {
    pageCount: 0,
    perPage: 10,
    page: 1
  },
  adoptionCounter: {
    adopted: 0,
    pending: 0
  },
  stationery: {
    items: [],
    isFetching: false,
    isError: false,
    messageError: null,
    paginate: {
      pageCount: 0,
      perPage: 10,
      page: 1
    }
  }
}

function AdoptionReducer (state = initialState, action) {
  switch (action.type) {
    case AdoptionActions.ADOPTIONS_MODAL_TOGGLE_VIEW:
      return {
        ...state,
        isModalOpen: !state.isModalOpen
      }
    // adoptions
    case AdoptionActions.ADOPTIONS_FETCH_REQUEST:
      return { ...state, isFetching: true }
    case AdoptionActions.ADOPTIONS_FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        adoptions: action.payload.data,
        paginate: {
          ...state.paginate,
          pageCount: Math.ceil(action.payload.totalCount / state.paginate.perPage)
        }
      }
    case AdoptionActions.ADOPTIONS_FETCH_ERROR:
      return { ...state, isFetching: false, isError: true, messageError: action.payload }
    case AdoptionActions.ADOPTIONS_DELETE_REQUEST:
      return { ...state, isFetching: true }
    case AdoptionActions.ADOPTIONS_DELETE_ERROR:
      return { ...state, isFetching: false, isError: true, messageError: action.payload }
    case AdoptionActions.ADOPTIONS_DELETE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        adoptions: state.adoptions.filter(adoption => adoption.id !== action.payload)
      }
    // stationery
    case AdoptionActions.STATIONERY_FETCH_REQUEST:
      return {
        ...state,
        stationery: {
          ...state.stationery,
          isFetching: true
        }
      }
    case AdoptionActions.STATIONERY_FETCH_SUCCESS:
      return {
        ...state,
        stationery: {
          ...state.stationery,
          items: action.payload.data,
          paginate: {
            ...state.stationery.paginate,
            pageCount: Math.ceil(action.payload.totalCount / state.stationery.paginate.perPage)
          },
          isFetching: false
        }
      }
    case AdoptionActions.STATIONERY_FETCH_ERROR:
      return {
        ...state,
        stationery: {
          ...state.stationery,
          isFetching: false,
          isError: true,
          messageError: action.payload
        }
      }
    // adoptions send
    case AdoptionActions.ADOPTIONS_SEND_FETCH_REQUEST:
      return { ...state, adoptionsSend: { ...state.adoptionsSend, isFetching: true } }
    case AdoptionActions.ADOPTIONS_SEND_FETCH_SUCCESS:
      return {...state, adoptionsSend: { ...state.adoptionsSend, items: action.payload.data, isFetching: false }}
    case AdoptionActions.ADOPTIONS_SEND_FETCH_ERROR:
      return {...state, adoptionsSend: { ...state.adoptionsSend, isFetching: false, isError: true, messageError: action.payload }}

    // segments
    case AdoptionActions.SEGMENTS_FETCH_REQUEST:
      return { ...state, isFetching: true }
    case AdoptionActions.SEGMENTS_FETCH_SUCCESS:
      return {...state, isFetching: false, segments: action.payload}
    case AdoptionActions.SEGMENTS_FETCH_ERROR:
      return {...state, isFetching: false, isError: true, messageError: action.payload}

    // adoption due date
    case AdoptionActions.ADOPTION_DUE_DATE_FETCH_REQUEST:
      return { ...state, isFetching: true }
    case AdoptionActions.ADOPTION_DUE_DATE_FETCH_SUCCESS:
      return {...state, isFetching: false, adoptionDueDate: action.payload}
    case AdoptionActions.ADOPTION_DUE_DATE_FETCH_ERROR:
      return {...state, isFetching: false, isError: true, messageError: action.payload}

    case AdoptionActions.ADOPTION_DUE_DATE_CHANGE_REQUEST:
      return { ...state, isFetching: true }
    case AdoptionActions.ADOPTION_DUE_DATE_CHANGE_SUCCESS:
      return {...state, isFetching: false, adoptionDueDate: action.payload}
    case AdoptionActions.ADOPTION_DUE_DATE_CHANGE_ERROR:
      return {...state, isFetching: false, isError: true, messageError: action.payload}

     // adoptions status
    case AdoptionActions.ADOPTION_STATUS_CHANGE_REQUEST:
      return { ...state, isFetching: true }
    case AdoptionActions.ADOPTION_STATUS_CHANGE_SUCCESS:
      return {...state, isFetching: false}
    case AdoptionActions.ADOPTION_STATUS_CHANGE_ERROR:
      return {...state, isFetching: false, isError: true, messageError: action.payload}

    // grades
    case AdoptionActions.GRADES_ADD:
      return {...state, grades: action.payload}
    case AdoptionActions.SET_GRADES_SELECTED:
      return {...state, selectedGrades: action.payload}

    // filters
    case AdoptionActions.FILTER_SET_GRADE_ID:
      return {...state, filterGradeId: action.payload}
    case AdoptionActions.FILTER_SET_SUBJECT_IDS:
      return {...state, filterSubjectIds: action.payload}
    case AdoptionActions.FILTER_SET_TEACHER_IDS:
      return {...state, filterTeacherIds: action.payload}
    case AdoptionActions.FILTER_SET_STATUS:
      return {...state, filterStatus: action.payload}
    case AdoptionActions.ADOPTIONS_CHANGE_ADVANCED_FILTER:
      return {
        ...state,
        advancedFilter:{
          ...state.advancedFilter,
          [action.payload.type]: action.payload.activeIds
        }
      }
    case AdoptionActions.ADOPTION_CHANGE_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          [action.payload.type]: action.payload.activeIds
        }
      }
    case AdoptionActions.ADOPTION_FILTER_RESET:
      return {
        ...state,
        filter: initialState.filter
      }
    // adoption counter adopted
    case AdoptionActions.ADOPTIONS_COUNTER_ADOPTED_FETCH_REQUEST:
      return { ...state, isFetching: true }
    case AdoptionActions.ADOPTIONS_COUNTER_ADOPTED_FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        adoptionCounter: {
          ...state.adoptionCounter,
          adopted: action.payload.total
        }
      }
    case AdoptionActions.ADOPTIONS_COUNTER_ADOPTED_FETCH_ERROR:
      return {...state, isFetching: false, isError: true, messageError: action.payload}

    // adoption counter pending
    case AdoptionActions.ADOPTIONS_COUNTER_PENDING_FETCH_REQUEST:
      return { ...state, isFetching: true }
    case AdoptionActions.ADOPTIONS_COUNTER_PENDING_FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        adoptionCounter: {
          ...state.adoptionCounter,
          pending: action.payload.total
        }
      }
    case AdoptionActions.ADOPTIONS_COUNTER_PENDING_FETCH_ERROR:
      return {...state, isFetching: false, isError: true, messageError: action.payload}
    // modal
    case AdoptionActions.ADOPTION_MODAL_TOGGLE_VIEW:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          isOpen: !state.dialog.isOpen
        }
      }
    case AdoptionActions.ADOPTION_MODAL_CHANGE_ITEM:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          item: action.payload
        }
      }
    case AdoptionActions.ADOPTION_CHANGE_PAGE:
      return {
        ...state,
        paginate: {
          ...state.paginate,
          page: action.payload
        }
      }
    case AdoptionActions.ADOPTION_STATIONERY_CHANGE_PAGE:
      return {
        ...state,
        stationery: {
          ...state.stationery,
          paginate: {
            ...state.stationery.paginate,
            page: action.payload
          }
        }
      }
    case AdoptionActions.TRIGGER_FETCH_ADOPTIONS_TO_BE_SENT:
      return {
        ...state,
        triggerFetchAdoptionsToBeSent: !state.triggerFetchAdoptionsToBeSent
      }
    default:
      return state
  }
}

export default AdoptionReducer



// WEBPACK FOOTER //
// ./src/modules/adoption/reducers.js